import { useDashboard } from "@platform/features/dashboard/DashboardContext";
import { SettingsPlanDetails } from "./SettingsPlanDetails";
import { useSupportSheet } from "@platform/features/support/hooks/useSupportSheet";

export function SettingsPlanDetailsContainer() {
  const { organization } = useDashboard();

  const { setSheetArticleId } = useSupportSheet();

  const handleLearnMoreClick = () => {
    setSheetArticleId("financials-faq");
  };

  return (
    <SettingsPlanDetails
      organizationName={organization?.name ?? ""}
      originalPrice="120"
      discountPrice="0"
      onLearnMoreClick={handleLearnMoreClick}
    />
  );
}

export default SettingsPlanDetailsContainer;
